import angular from 'angular';
import 'angular-ui-router';
import template from './feeForm.jade';

export class FeeFormController {
  /* @ngInject */
  constructor($filter) {
    this.translate = $filter('translate');
    this.fields = [
      {
        className: 'layout__item u-1/3',
        type: 'input',
        key: 'volume_from',
        hideExpression: 'model.type !== "service_fee"',
        templateOptions: {
          label: this.translate('volume_from') + ' ($)',
          required: true
        }
      },
      {
        className: 'layout__item u-1/3',
        type: 'input',
        key: 'volume_to',
        hideExpression: 'model.type !== "service_fee"',
        templateOptions: {
          label: this.translate('volume_to') + ' ($)',
          required: true
        }
      },
      {
        className: `layout__item ${this.fee.type !== 'service_fee' ? 'u-1/1' : 'u-3/12'}`,
        type: 'input',
        key: 'fee',
        templateOptions: {
          label: this.translate(`$fee_type.${this.fee.type}.label`),
          help: this.fee.type !== 'service_fee' ? this.translate(`$fee_type.${this.fee.type}.help`) : null,
          required: true
        }
      },
      {
        className: 'layout__item u-1/12 u-pt+',
        hideExpression: 'model.type !== "service_fee"',
        template: `<a id="fee-remove-btn" ng-click="model.removed=true" class="o-btn c-btn c-btn--icon c-btn--danger">
          <span gg-icon="icon-trash"></span>
        </a>`
      }
    ];
  }
}

export function GameDevelopersFormComponent() {
  return {
    template,
    controller: FeeFormController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      fee: '=',
      fees: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.admin.fees.form', [])
  .directive('feeForm', GameDevelopersFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/admin/gameDevelopers/feeForm.js
 **/